import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { getAssignees } from 'bundles/apex/planner/helpers';
import { setAssignee } from 'bundles/apex/deals/show/store/planner_filters/actions';
import SidebarBrokerFilter from 'components/search_sidebar/broker_filter';

export function AssigneeFilters({ deal, selectedAssigneeId, setAssignee }) {
  const assignees = getAssignees(deal);

  return (
    <SidebarBrokerFilter
      brokers={assignees}
      classNamePrefix="dropdown-filter"
      isClearable={!!selectedAssigneeId}
      selectedBrokerId={selectedAssigneeId}
      onChange={assignee => setAssignee(assignee?.id || null)}
    />
  );
}

AssigneeFilters.propTypes = {
  deal: PropTypes.object.isRequired,
  selectedAssigneeId: PropTypes.number,
  setAssignee: PropTypes.func.isRequired,
};

const mapStateToProps = ({ deal, plannerFilters: { selectedAssigneeId } }) => {
  return {
    deal,
    selectedAssigneeId
  };
};

const mapDispatchToProps = {
  setAssignee
};

export default connect(mapStateToProps, mapDispatchToProps)(AssigneeFilters);
